import React from 'react';
import BreadcrumbsManager from '@views/dashboard/BreadcrumbsManager';
import OrderUpdateForm from '@views/orders/OrderUpdateForm';

export default function OrderForm(props: Omit<React.ComponentProps<typeof BreadcrumbsManager>, 'children'>) {
    return <BreadcrumbsManager {...props}>
        <OrderUpdateForm controllerName="Orders" isIsolatedComponent/>
    </BreadcrumbsManager>;
}
